var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":_vm.eIdData.button.language[_vm.buttonLanguage],"alt":_vm.eId + ' button',"height":_vm.eIdData.button.height},on:{"click":_vm.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }